import "./index.css";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import { ToastContainer, toast } from "react-toastify";
import { sendAnalitics } from "../../../../services/Store/Actions/appActions";
import { Button } from "reactstrap";
import CreateCardWallet from "../CreateCardWallet";
import copy from "copy-to-clipboard";
import CardWalletAllTransactionWallet from "../../../Modals/CardWalletAllTransactionModal";
import { clearCardWalletHistory, getCardWalletHistory } from "../../../../services/Store/Actions/walletAction";

const CardWalletDiv = (props) => {
  const { cardWallet } = useSelector((state) => state?.wallet);
  const cashBackBalance =
  cardWallet?.data?.balance === undefined
      ? 0.0
      : (cardWallet?.data?.balance).toFixed(2);
  const redeemedBalance = cardWallet?.data?.redeem;
  const remainingBal = (cashBackBalance - redeemedBalance).toFixed(2);
  console.log("CardWalletDiv", cardWallet);
  const handleShow1 = () => {};

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(sendAnalitics("CB_Web"));
  }, []);

  // for the cashback transaction modal
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const handleClose = () => {
    setOpen(false);
    //setProceed(0);
    //console.log("closed");
  };

  function toggleModal() {
    setOpen(!open);
    //setProceed(0);
  }

  const handleShow = () => {
    dispatch(sendAnalitics("History_CB_Web"));
    dispatch(clearCardWalletHistory())
    dispatch(getCardWalletHistory({
      offset: 0,
      limit: "",
      // from: moment(startDate).format("YYYY-MM-DD"),
      // to: moment(endDate).format("YYYY-MM-DD"),
    }, (res)=> {
      console.log("getCardWalletHistory",res);
    }))
    setOpen(true);

    //console.log(a);
  };
  // this is for the redeem modal

  const [open3, setOpen3] = useState(false);

  const toggleModal3 = () => {
    setOpen3(!open3);
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  const handleShow3 = () => {
    // disabled redeem cashback
    setOpen3(true);
    dispatch(sendAnalitics("cardWallet_KYC"));
  };

  const [ copyIcon, setCopyIcon] = useState(false)
  const [ copyIconIfsc, setCopyIconIfsc] = useState(false)
 
  const customId1 = "custom-id-accountCopy page";
  const notify1 = () => toast.success("Bank Account Number was successfully copied.",{
    toastId:customId1,
    position: "top-right",
  });

  const customId2 = "custom-id-ifscCopy page";
  const notify2 = () => toast.success("IFSC Code was successfully copied.",{
    toastId:customId2,
    position: "top-right",

  });
 
  const copyToClipboard = () => {
    dispatch(sendAnalitics("Copy_Ac_Web"));
    copy(cardWallet?.ecollectAccountNumber);
    notify1();
    setCopyIcon(1);
    setCopyIconIfsc(0);
    dispatch(sendAnalitics("Copy_Ac_Web"));
    //alert(`You have copied "${link}"`);
  };

  const copyToClipboardIfsc = () => {
    dispatch(sendAnalitics("Copy_IFSC_Web"));
    copy(cardWallet?.ifscCode);
    setCopyIconIfsc(1);
    setCopyIcon(0);
    notify2();
    //alert(`You have copied "${link}"`);
  };
  return (
    <div className=" ">
      <div className="row padding16T">
        <div className="col-1">
          <SvgImage name="HomeCashback" />
        </div>
        <div className="col-6 heading2 Bold">Card Wallet</div>
        <div
          className="col-5 flexStyling greenFont heading3 semiBold pointing padding0R padding32L"
          // style={{ paddingLeft: "1.4rem" }}
          onClick={() => cardWallet?.status ? handleShow() : null}
          
        >
          Card Wallet History
          <div style={{ marginTop: "-0.2rem" }}>
            <SvgImage name="ForwardArrow" height="32" width="32" />
          </div>
        </div>
         {
        <CardWalletAllTransactionWallet
          Title="Card Wallet"
          open={open}
          toggleModal={toggleModal}
          handleClose={handleClose}
        />
      }
      </div>
      <div className="row">
       { cardWallet?.status ? <div className="col-4 padding16T">
          <div className="textDiv semiBold">Balance</div>
          <div className="text1 semiBold greenColor ">₹{cardWallet?.balance}</div>
        </div> :  <div className="col-4 "></div>}
          {cardWallet?.status ?  <div className="col-4 padding16T">
            <div className="textDiv semiBold">Account No</div>
            <div className="text1">{cardWallet?.sourceAccount}</div>
          </div>:  <div className="col-4 "></div>}
          {cardWallet?.status ? 
          <div className="col-4 padding16T">
            <div className="textDiv semiBold">IFSC</div>
            <div className="text1 ">{cardWallet?.sourceIfsc}</div>
          </div>:<div className="col-4 padding16T">
          <Button
          onClick={handleShow3}>
              CompleteKYC
          </Button>
          </div>}
         
      </div>
      {cardWallet.status ? 
      <div className="row padding32T padding32B">
        <hr style={{width: "90%",border:"2px solid", marginLeft:"20px"}}></hr>
        <div className="row col-6 padding16T">
          <div className="col-8"> 
            <div className="textDiv semiBold">YBL Account No</div>
            <div className="text1 semiBold greenColor ">{cardWallet?.ecollectAccountNumber}</div>
          </div>
          <div className="col-4" onClick={copyToClipboard} style={{cursor:"pointer", marginTop: "-3px"}}>
            {!copyIcon ? (
              <SvgImage
                name="CopyLogo"
              />
            ) : (
              <SvgImage
                name="CopiedLogo"
              />
            )}
          </div>
         
        </div>
        <div className="row col-6 padding16T">
          <div className="col-8"> 
            <div className="textDiv semiBold">YBL IFSC</div>
            <div className="text1 semiBold greenColor ">{cardWallet?.ifscCode}</div>
          </div>
          <div className="col-4" onClick={copyToClipboardIfsc} style={{cursor:"pointer", marginTop: "-3px"}}>
              {!copyIconIfsc ? (
                <SvgImage
                  name="CopyLogo"
                />
              ) : (
                <SvgImage
                  name="CopiedLogo"
                />
              )}
            </div>
        </div>
     </div> : <></>}
     
       {
        <CreateCardWallet
          modal={open3}
          toggle={toggleModal3}
          setModal={setOpen3}
        />
      }
    </div>
  );
};

export default CardWalletDiv;
